import actionTypes from '../../action-types'

export default () => ({
  type: actionTypes.ADMINISTRATOR_PERMISSIONS.FETCH,
})
